import { CSSProperties, PropsWithChildren } from 'react';
import { CircularProgress, Container, Typography } from '@mui/material';

import { UserRoles } from '@lifeserver/shared';

import { useIsAuthorized } from '../hooks/useIsAuthorized';

import FaceSadTearIcon from '../portal/model/components/assets/face-sad-tear.svg';

interface ProtectedComponentProps extends PropsWithChildren {
    className?: string;
    style?: CSSProperties;
    role: UserRoles;
}

export function ProtectedComponent({
    role,
    className,
    style,
    children,
}: ProtectedComponentProps) {
    const authorization = useIsAuthorized(role);

    if (authorization.isLoading) {
        return <CircularProgress className={className} style={style} />;
    } else if (!authorization.isAuthorized) {
        return (
            <Container className={className} style={style}>
                <Typography variant="h1">
                    <img
                        style={{
                            width: '1em',
                            height: '1em',
                            verticalAlign: 'baseline',
                        }}
                        src={FaceSadTearIcon}
                    />
                    Unauthorized
                </Typography>
                <Typography>
                    You don't have permission to visit this page. To gain
                    access, you need the '{role}' role.
                </Typography>
            </Container>
        );
    } else {
        return children;
    }
}
